import { render, staticRenderFns } from "./StageModal.vue?vue&type=template&id=cafa3d12&scoped=true&"
import script from "./StageModal.vue?vue&type=script&lang=js&"
export * from "./StageModal.vue?vue&type=script&lang=js&"
import style0 from "./StageModal.vue?vue&type=style&index=0&id=cafa3d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafa3d12",
  null
  
)

export default component.exports